export default "__VITE_ASSET__LMHqNMod__"